import { Icon } from '@vinted/web-ui'
import { ArrowLeft24, ArrowRight24 } from '@vinted/monochrome-icons'

import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { InfluencerTipsModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import SliderWrapper from '../../../../components/SliderWrapper/SliderWrapper'
import { TipsSectionCard } from './TipsSectionCard'

type Props = { data: InfluencerTipsModel }

export const TipsSection = ({ data: { title, cards } }: Props) => {
  return (
    <section data-testid="tips-section" className="influencer__tips-section">
      <h2 className="influencer__tips-title">{title}</h2>
      <div className="influencer__tips-cards-wrapper">
        <ShowAtBreakpoint breakpoint="portables">
          <SliderWrapper
            childData={cards.map((card, index) => ({ index, ...card }))}
            childComponent={TipsSectionCard}
            nextButton={<Icon name={ArrowRight24} />}
            previousButton={<Icon name={ArrowLeft24} />}
          />
        </ShowAtBreakpoint>
        <ShowAtBreakpoint breakpoint="desktops">
          {cards.map((props, index) => (
            <TipsSectionCard {...props} key={index} index={index} />
          ))}
        </ShowAtBreakpoint>
      </div>
    </section>
  )
}
